import React from "react";

const SsoButton = ({ onClick, showDivider = true }) => {
  return (
    <div style={{ margin: "20px 0", textAlign: "center" }}>
      {showDivider && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            margin: "20px 0",
          }}
        >
          <div
            style={{ flex: 1, height: "1px", background: "#ddd" }}
          ></div>
          <span style={{ padding: "0 10px", color: "#666" }}>OR</span>
          <div
            style={{ flex: 1, height: "1px", background: "#ddd" }}
          ></div>
        </div>
      )}

      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (onClick) {
            onClick(e);
          }
        }}
        style={{
          width: "100%",
          padding: "12px",
          background: "#fff",
          border: "2px solid #7f56d9",
          borderRadius: "5px",
          color: "#7f56d9",
          fontSize: "16px",
          fontWeight: "600",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 2L2 7L12 12L22 7L12 2Z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M2 17L12 22L22 17"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M2 12L12 17L22 12"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
        Login with SSO
      </button>
    </div>
  );
};

export default SsoButton;

